import { getWindowLocationOrigin } from '../../utils/window'
import { generateMetaTags } from '../../utils/helmet'

const title = 'Pricing Plans for Prospect | IrisVR'
const description =
  'Pricing for Prospect, VR software used by Architecture & Construction industries to do VR walkthroughs of SketchUp, Revit, Navisworks, Rhino 3D models + panoramas.'
const url = `${getWindowLocationOrigin()}/pricing`
const image = 'https://s3.amazonaws.com/iris-opengraph-images/ImgTag_Iris.jpg'
const imageWidth = 1200
const imageHeight = 630

export default generateMetaTags({
  title,
  description,
  image,
  url,
  imageWidth,
  imageHeight,
})
